module.exports = __webpack_public_path__ + "img/val.78253340.png";